








import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'Body'
})
export default class Body extends Vue {
}
